import {
  getAddressInfo,
  getDefaultAddress
} from '@/api/address'


// 获取默认地址
export const getDefaultAddr = async () => {
  try {
    const result = await getDefaultAddress()
    const addressInfo = result.data.data.addressInfo
     if (Object.keys(addressInfo).length !== 0) {
       return {
          status: true,
         addressInfo: addressInfo
       }
     } else {
       return {
        status: false,
        addressInfo: {}
       }
       // throw new Error('未找到默认地址')
     }
  } catch (error) {
    throw error
  }
}

// 根据id获取地址详情
export const getAddress = async (addressId) => {
  try {
    const result = await getAddressInfo({
      address_id: addressId
    })
    const data = result.data.data
    return {
      status: data.status,
      addressInfo: data.addressInfo
    }
  } catch (error) {
    throw error
  }
}

// 获取当前地址
export const getCurrentAddress = async ({ state, commit }) => {
  try {
    if (state.addressId) {
      const address = await getAddress(state.addressId)
      if (address.status) {
        commit('setAddressInfo', address.addressInfo)
      }
      return address
    } else {
      const address = await getDefaultAddr()
      if (address.status) {
        commit('setAddressInfo', address.addressInfo)
      }
      return address
    }
  } catch (error) {
    throw error
  }
}
